window.addEventListener("load", () => {
	function addScrollClasses(e) {

		var scrollTop = window.pageYOffset || document.documentElement.scrollTop;

		if (scrollTop > 0) {
			document.body.classList.add('scroll-below-top');
			document.body.classList.remove('scroll-at-top');
		} else {
			document.body.classList.remove('scroll-below-top');
			document.body.classList.add('scroll-at-top');
		}

	}

	window.addEventListener("scroll", addScrollClasses);

	document.querySelector('.scroll-top').addEventListener('click', function() {
		window.scrollTo({
			top: 0,
			behavior: 'smooth'
		});
	});

	addScrollClasses();
});